import { useEffect, useState } from 'react'

const useScript = (src) => {
  const [isScriptLoaded, setIsScriptLoaded] = useState(false)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = src
    script.async = true

    script.addEventListener('load', () => {
      setIsScriptLoaded(true)
    })

    document.head.appendChild(script)

    return () => {
      document.head.removeChild(script)
    }
  }, [src])

  return isScriptLoaded
}

export default useScript
